import React from 'react';
import PropTypes from 'prop-types';
import { CodePenButton } from '../';
import { ReadIcon } from './';

const FooterLinks = ({ optionsString, docsUrl }) =>
  <ul className="footer-links">
    <li>
      <a href={docsUrl} target="_blank" rel="noopener noreferrer">
        <ReadIcon />
        Read the docs
      </a>
    </li>
    <li>
      <CodePenButton optionsString={optionsString} />
    </li>
  </ul>;

FooterLinks.propTypes = {
  optionsString: PropTypes.string.isRequired,
  docsUrl: PropTypes.string.isRequired
};

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/components/FooterLinks/FooterLinks.js


// WEBPACK FOOTER //
// webpack:///src/components/FooterLinks/FooterLinks.js